import styled from 'styled-components';

import { TAG_SIZES, TagGroup } from 'ui/tags';
import { useGetJourneyDetails } from 'modules/userProfiles/events/history/hooks/useGetJourneyDetails';
import { IdDisplay } from './IdDisplay';
import { NameLabel } from './NameLabel';

interface JourneyDetailsProps {
  workflowId: number;
}

const StyledTagGroup = styled(TagGroup)`
  div:first-child {
    margin-left: 0;
  }
`;

/**
 * Renders a link to the journey that is linked to the event
 */
export const JourneyDetails = ({ workflowId }: JourneyDetailsProps) => {
  const { workflowType, name, labels } = useGetJourneyDetails(workflowId);
  const labelNames = labels?.map((label: { name: string }) => label.name);

  return (
    <div data-test="event-history-journey">
      <NameLabel href={`/workflows/${workflowId}/edit?mode=beta&workflowType=${workflowType}`}>
        {name}
      </NameLabel>
      <IdDisplay id={workflowId} />
      {!!labelNames?.length && (
        <StyledTagGroup value={labelNames} tagSize={TAG_SIZES.SMALL} maxTags={2} />
      )}
    </div>
  );
};
